import { Card, makeStyles, Divider, Grid, Skeleton, useIsMobile } from '@paintscout/ui'
import times from 'lodash/times'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  column: {
    height: '70vh',
    overflowY: 'hidden'
  },
  cardContainer: {
    backgroundColor: theme.paintscout.palette.brand.Neutral.P94,
    borderRadius: theme.borderRadius.md,
    height: '100%',
    padding: theme.spacing(2)
  },
  blue80: {
    backgroundColor: theme.paintscout.palette.brand.Blue.Blue80
  },
  p80: {
    backgroundColor: theme.paintscout.palette.brand.Neutral.P80
  },
  p90: {
    backgroundColor: theme.paintscout.palette.brand.Neutral.P90
  },
  card: {
    height: '130px',
    width: '100%',
    marginBottom: theme.spacing(2),
    borderRadius: theme.borderRadius.md
  },
  cardTop: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
    '& > *': {
      marginBottom: theme.spacing(0.5)
    }
  },
  cardBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingTop: 0
  }
}))

export function BoardViewShim() {
  const classes = useStyles()
  const mobile = useIsMobile()

  const CardSkeleton = () => {
    return (
      <Card className={classes.card}>
        <div className={classes.cardTop}>
          <Skeleton className={classes.p80} variant="rect" width="70%" height="16px" />
          <Skeleton className={classes.p90} variant="rect" width="35%" height="16px" />
          <Skeleton className={classes.p90} variant="rect" width="15%" height="16px" />
        </div>
        <Divider />
        <div className={classes.cardBottom}>
          <Skeleton className={classes.p80} variant="rect" width="25px" height="25px" style={{ borderRadius: '50%' }} />
          <Skeleton className={classes.p90} variant="rect" width="10%" height="16px" />
        </div>
      </Card>
    )
  }

  const ColumnSkeleton = ({ cards }: { cards: number }) => {
    return (
      <div className={classes.column}>
        <Skeleton className={classes.blue80} variant="rect" width="40%" style={{ marginBottom: '12px' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
          <Skeleton className={classes.p80} variant="rect" width="12%" />
          <Skeleton className={classes.p80} variant="rect" width="12%" />
        </div>
        <div className={classes.cardContainer}>
          {times(cards, (i) => (
            <CardSkeleton key={i} />
          ))}
        </div>
      </div>
    )
  }

  const cardsMap = [3, 4, 2, 3, 2]

  return (
    <Grid container spacing={3}>
      {times(mobile ? 2 : 4, (i) => (
        <Grid item xs={6} md={3} key={i}>
          <ColumnSkeleton cards={cardsMap[i]} />
        </Grid>
      ))}
    </Grid>
  )
}
